<template>
  <div class="table-footer">
    <v-pagination
      :length="pagination.lastPage"
      :total-visible="totalVisible"
      :value="pagination.currentPage"
      :disabled="pagination.lastPage === 1"
      color="blue darken-3"
      class="pb-4 pt-4"
      @input="$emit('onChangePage', $event)"
    />

    <v-autocomplete
      class="table-footer__autocomplete"
      item-value="id"
      item-text="id"
      label="Элементов на странице"
      placeholder="Количество"
      hide-details
      :value="pagination.perPage"
      :items="itemsPerPage"
      @change="$emit('changePerPage', $event)"
    />
  </div>
</template>

<script>
export default {
  name: 'table-footer',

  props: {
    pagination: {
      type: Object,
      required: true,
    },
    totalVisible: {
      type: Number,
      default: 8,
    },
    itemsPerPage: {
      type: Array,
      default: () => ([
        { id: 12 },
        { id: 24 },
        { id: 36 },
        { id: 48 },
        { id: 60 },
      ]),
    },
  },
};
</script>

<style lang="scss" scoped>
  .table-footer {
    display: flex;
    align-items: baseline;
    justify-content: center;

    &__autocomplete {
      padding: 15px 15px 0;
    }
  }
</style>
